import React from 'react'
import { Eye } from '@phosphor-icons/react'
import { Icon, Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@shopflo/ui'
import { useDiscountForm } from '../../hooks/useDiscountForm'
import { UiConfigDiscountType } from 'src/lib/types/discountsV2'

const DiscountVisibilitySelector = () => {
  const {
    state: { prerequisite, entitlement, uiConfig },
    actions: { setFormState }
  } = useDiscountForm()

  const { availability } = prerequisite
  const { applicationMethod } = entitlement

  if (applicationMethod.autoApplicable || uiConfig.type === UiConfigDiscountType.EXIT_COUPON) {
    return <></>
  }

  return (
    <div className='flex flex-col w-full px-3 hover:bg-zinc-500/5 rounded-xl'>
      <Select
        value={availability.discoverable ? 'visible' : 'hidden'}
        onValueChange={value => {
          setFormState({
            prerequisite: {
              ...prerequisite,
              availability: {
                ...availability,
                discoverable: value === 'visible'
              }
            }
          })
        }}
      >
        <SelectTrigger className='w-[260px] border-none p-0 h-auto shadow-none focus:ring-0 group hover:bg-transparent flex items-center justify-start gap-1.5 cursor-pointer py-3'>
          <Icon IconComponent={Eye} size='sm' className='text-zinc-400' />
          <span className='text-text-sm-regular text-zinc-500'>Visible to </span>
          <span className='text-text-sm-semibold text-zinc-600 transition-colors group-hover:text-zinc-700 !lowercase'>
            <SelectValue />
          </span>
        </SelectTrigger>
        <SelectContent align='start' className='w-[260px]'>
          <SelectItem value='visible'>
            <span>All customers</span>
          </SelectItem>
          <SelectItem value='hidden'>
            <span>None</span>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}

export default DiscountVisibilitySelector
